import { GET_LEARNER_NEW_PROGRESS , GET_LEARNER_NEW_PROGRESS_SUCCESS , GET_LEARNER_NEW_PROGRESS_FAILURE, TRIGGER_TOAST } from "../constants";
import { API, graphqlOperation } from "aws-amplify";
import { GetLearnerNewProgress } from "../../queries";


export const getLearnerNewProgressDetailsAction = (uId : string, level: string, productId: number, language: string) => {
 return async (dispatch: any) => {
  dispatch({type: GET_LEARNER_NEW_PROGRESS});
  const getlearnerCourseDetails = API.graphql(graphqlOperation(GetLearnerNewProgress, {uId, level, productId, language})) as Promise<any>;
        getlearnerCourseDetails.then(async (courseDetails: any) => {
        let response = JSON.parse(courseDetails.data.getLearnerProgressDetails);        
        if (response !== "") {
          dispatch({ type: GET_LEARNER_NEW_PROGRESS_SUCCESS, payload: { ...response } });
        } else {
          // handleError(err);
          dispatch({ type: GET_LEARNER_NEW_PROGRESS_FAILURE });
          dispatch({
            type: TRIGGER_TOAST,
            payload: {
              shouldShow: true,
              severity: "error",
              transMessage: "message_errorDefault",
            },
          });
        }
      }).catch((err: any) => {
        dispatch({ type: GET_LEARNER_NEW_PROGRESS_FAILURE });
        dispatch({
          type: TRIGGER_TOAST,
          payload: {
            shouldShow: true,
            severity: "error",
            transMessage: "message_errorDefault",
          },
        });
      });
 }
}

export default {
  getLearnerNewProgressDetailsAction,
}